import { render, staticRenderFns } from "./uninjuryDetail.vue?vue&type=template&id=57d7c9d8"
import script from "./uninjuryDetail.vue?vue&type=script&lang=js"
export * from "./uninjuryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d7c9d8')) {
      api.createRecord('57d7c9d8', component.options)
    } else {
      api.reload('57d7c9d8', component.options)
    }
    module.hot.accept("./uninjuryDetail.vue?vue&type=template&id=57d7c9d8", function () {
      api.rerender('57d7c9d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/noaccident/uninjuryDetail.vue"
export default component.exports